import { useState } from "react";
import { sideTabTitle, sideTabCard } from "../../data/SideTabData";
import { SideTabCard, SideTabs, TabTitle, Slide, CardStack } from "./styles";

export default function SideTabDesktop() {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <SideTabCard>
      <SideTabs>
        {sideTabTitle.map((item, index) => (
          <TabTitle
            key={index}
            isActive={activeIndex === index}
            onClick={() => setActiveIndex(index)}
          >
            {item.title}
          </TabTitle>
        ))}
      </SideTabs>

      <Slide>
        <CardStack variant={sideTabCard[activeIndex].overlayPosition}>
          <div className="CardContent">
            <div className="DescriptionCard">
              {sideTabCard[activeIndex].description}
            </div>
            <div className="OverlayTitle">
              {sideTabCard[activeIndex].overlayTitle}
            </div>
            <div className="OverlaySubtitle">
              {sideTabCard[activeIndex].overlaySubtitle}
            </div>
          </div>
          <div className="ImageWrapper">
            <img src={sideTabCard[activeIndex].image} alt="" />
          </div>
        </CardStack>
      </Slide>
    </SideTabCard>
  );
}
